import React from 'react'
import TextLink from 'components/redesign/TextLink'

const UnderlinedHeader = ({ children, linkText, url }) => (
  <div className='flex items-center justify-between mv8 bb-medium b--precedents-blue'>
    <h2 className='tl mv0 f4'>{children}</h2>
    <TextLink text={linkText} textCx='f6' url={url} />
  </div>
)

export default UnderlinedHeader
